import React from 'react'

export const HomeIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M19 12H12V17H22V15C22 13.3431 20.6569 12 19 12Z" fill="#BDBDBD" />
		<path d="M16.1667 7H12V13H20L18.0128 8.23077C17.7023 7.48548 16.9741 7 16.1667 7Z" fill="#BDBDBD" />
		<path d="M15.2796 8H14V12H18L17.1886 9.40345C16.9277 8.5685 16.1544 8 15.2796 8Z" fill="white" />
		<circle cx="8.5" cy="17.5" r="2.5" fill="#BDBDBD" />
		<circle cx="17.5" cy="17.5" r="2.5" fill="#BDBDBD" />
		<path d="M2 14V4H12C13.6569 4 15 5.34315 15 7V17H5C3.34315 17 2 15.6569 2 14Z" fill="#4A4A4A" />
	</svg>
)
